import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-range-picker',
  templateUrl: './range-picker.component.html',
  styleUrls: ['./range-picker.component.scss']
})
export class RangePickerComponent implements OnInit {

  @Input() lower = 0;
  @Input() higher = 500000;

  @Input() min = 0;
  @Input() max = 1000000;

  @Input() step = 10000;

  @Input() name!: string;
  @Input() label = false;
  @Input() placeholder = '';
  // @Input() myForm!: NgForm;

  // @Input() required = false;

  @Output() lowerChange = new EventEmitter<number>();
  @Output() higherChange = new EventEmitter<number>();

  rangeValues: number[] = [100000, 650000];

  constructor() { }

  ngOnInit(): void {
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if ('lower' in changes && changes.lower.currentValue !== undefined) {
      this.lower = changes.lower.currentValue;
      this.rangeValues = [Number(this.lower), Number(this.higher)];
    }

    if ('higher' in changes && changes.higher.currentValue !== undefined) {
      this.higher = changes.higher.currentValue;
      this.rangeValues = [Number(this.lower), Number(this.higher)];
    }
  }

  eventChange(): void {
    this.lower = this.rangeValues[0];
    this.higher = this.rangeValues[1];
    this.lowerChange.emit(this.rangeValues[0]);
    this.higherChange.emit(this.rangeValues[1]);
  }

}
